import moment from "@wielink-application/shared/js/mixins/moment";

export default {
	mixins: [moment],
	methods: {
		setCustomerDetails(appointment, start_date_selector, event) {
			if(!event.params)  {
				return;
			}

			let customer = event.params.data;

			appointment.available_products = this.parseProducts(customer, customer.products ?? []);
			appointment.name = this.parseName(customer);
			appointment.default_duration = customer.duration_in_minutes;

			$(start_date_selector).trigger('customchange');
		},

		setEndDate(appointment, event) {
			let date = this.moment(appointment.start_date).add(appointment.default_duration, 'minutes');
			appointment.end_date = date.format('YYYY-MM-DD HH:mm');
		},

		parseProducts(customer, products) {
			return products.map((product) => {
				let label = `${product.product.serial_number} | ` + this.dateFormat(product.valid_until);
				if(product.planned) {
					label += ' | INGEPLAND'
				}

				let duration = 0;
				if(product.product.type_tester && product.product.type_tester.appointment_duration_in_minutes) {
					duration = product.product.type_tester.appointment_duration_in_minutes;
					label += ` | ${product.product.type_tester.appointment_duration_in_minutes}min`;
				}

				return {
					label: label,
					value: product.id,
					duration: duration,
				}
			});
		},

		parseName(customer) {
			let parts = [
				customer.full_address,
				customer.name
			];
			return parts.filter(part => !!part).join(' - ');
		}
	}
}